/* eslint-disable */
export default {
  matched: 'Con corrispondenza',
  other: 'Altro',
  associated: 'Associati',
  foundFromServer: 'Risultati da {appName}',
  recently: 'Recenti',
  additionalLabelAccount: 'Account: {displayName}',
  additionalLabelContact: 'Contatto: {displayName}',
  notFound: 'N/D',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
